import PageHeader from "../components/PageHeader";

export default function AMLKYC() {
  return (
    <div data-testid="aml-kyc-page">
      <PageHeader eyebrow="Compliance" title="AML / KYC Policy" subtitle="Last updated: November 2025" />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose-blog">
        <p>CashPark Inc is fully committed to preventing money laundering, terrorist financing, and other financial crimes. This policy outlines the controls we apply across our NGN↔CAD operations.</p>
        <h2>1. Customer Due Diligence (CDD)</h2>
        <p>Every customer is required to complete identity verification before initiating any transfer. We collect and verify:</p>
        <ul>
          <li>Full legal name, date of birth, and residential address</li>
          <li>Government-issued photo identification</li>
          <li>Source of funds, where applicable</li>
          <li>Purpose of the transfer for amounts above regulatory thresholds</li>
        </ul>
        <h2>2. Enhanced Due Diligence (EDD)</h2>
        <p>EDD is performed on Politically Exposed Persons (PEPs), customers from high-risk jurisdictions, and any unusually large or complex transactions. Additional documentation and senior approval are required.</p>
        <h2>3. Sanctions screening</h2>
        <p>All customers and counterparties are screened against UN, OFAC, OSFI (Canada), and other relevant sanctions lists at onboarding and on an ongoing basis.</p>
        <h2>4. Transaction monitoring</h2>
        <p>We monitor transactions in real time for unusual patterns, structuring, layering, and inconsistencies with the customer's profile. Suspicious activity is investigated promptly.</p>
        <h2>5. Reporting obligations</h2>
        <p>We file Suspicious Transaction Reports (STRs) and Large Cash Transaction Reports (LCTRs) with FINTRAC as required by the Proceeds of Crime (Money Laundering) and Terrorist Financing Act (PCMLTFA), and cooperate fully with Nigerian financial intelligence authorities for the receiving side.</p>
        <h2>6. Record keeping</h2>
        <p>We retain customer identification, transaction records, and supporting documentation for a minimum of five (5) years.</p>
        <h2>7. Training</h2>
        <p>All employees receive AML/CTF training at onboarding and at least annually thereafter. Our compliance officer reports directly to senior management.</p>
        <h2>8. Whistleblowing & escalation</h2>
        <p>To report suspected money laundering or sanctions violations involving CashPark, email <a href="mailto:contact@mycashpark.com">contact@mycashpark.com</a>. Reports may be made anonymously.</p>
      </section>
    </div>
  );
}
